module.exports = __webpack_public_path__ + "img/24000.8665b016.jpg";